export function getApiErrorInfo(error) {
  const data = error?.response?.data;
  return {
    message: data?.error || error?.message || 'Request failed',
    code: data?.code,
    fromCurrency: data?.fromCurrency,
    toCurrency: data?.toCurrency,
  };
}

export function isMissingExchangeRateError(error) {
  return error?.response?.data?.code === 'MISSING_EXCHANGE_RATE';
}
